import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import Button from '../button/Button';
import './NewDialog.scss';

const NewDialog = ({
  positiveButtonText,
  negativeButtonText,
  onPositiveButtonClick,
  onNegativeButtonClick,
  hideNegativeButton,
  opacity = false,
  children,
  onBackArrowClick,
}) => (
  <div className={classnames('new-dialog', opacity ? 'transparent' : 'not-transparent')}>
    <div className="dialog-container">
      <div className="dialog-header">
        <div className="arrow" onClick={onBackArrowClick}>
          <FontAwesomeIcon className="arrow-icon" icon={faChevronLeft} />
        </div>
      </div>
      <div className="dialog-body">
        {children}
      </div>
      <div className="dialog-footer">
        <Button type="button" className="positive-button" text={positiveButtonText} onClick={onPositiveButtonClick} fontSize={12} />
        {!hideNegativeButton && (
        <Button type="button" className="negative-button" text={negativeButtonText} onClick={onNegativeButtonClick} fontSize={12} />
        )}
      </div>
    </div>
  </div>
);

NewDialog.propTypes = {
  positiveButtonText: PropTypes.string.isRequired,
  negativeButtonText: PropTypes.string,
  onPositiveButtonClick: PropTypes.func.isRequired,
  onNegativeButtonClick: PropTypes.func,
  hideNegativeButton: PropTypes.bool,
  opacity: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  onBackArrowClick: PropTypes.func,
};

export default NewDialog;
